import request from '../utils/request'

export async function all (url, params) {
  return request(url, {
    method: 'GET',
    data: params
  })
}

export async function get (url, objectId, params) {
  return request(url + `/${objectId}`, {
    method: 'GET',
    data: params
  })
}

export async function create (url, params) {
  return request(url, {
    method: 'POST',
    data: params
  })
}

export async function update (url, objectId, params) {
  return request(url + `/${objectId}`, {
    method: 'PUT',
    data: params
  })
}

export async function remove (url, objectId) {
  return request(url + `/${objectId}`, {
    method: 'DELETE'
  })
}


// WEBPACK FOOTER //
// ./src/services/restApi.js